// src/routes/PublicRoute.jsx
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { ROUTE_PATHS } from "../config/constants";

const PublicRoute = () => {
  const { isAuthenticated, initializing } = useAuth();

  if (initializing) {
    return <div>Loading...</div>;
  }

  return !isAuthenticated ? (
    <Outlet />
  ) : (
    <Navigate to={ROUTE_PATHS.DASHBOARD} replace />
  );
};

export default PublicRoute;
